import AF from '../utlis/AF';
import { isMobile } from '../utlis/is-mobile';

const CLASS_PRESSED = 'is-pressed';
const CLASS_NEXT = 'is-next';
const CLASS_BACK = 'is-back';
const CLASS_ACTIVE = 'is-active';
const CLASS_HIDDEN = 'is-hidden';

export default class ClickCursor {
  _instance;
  active = false;
  currentType = null;
  initialised = false;
  pressed = false;
  x = 0;
  y = 0;

  static instance(){
      if(this._instance) return this._instance;
      return this._instance = new this();
  }

  constructor(el) {
      if (!isMobile) {
          this.initialised = true;
          this.el = document.querySelector('[click-cursor]');
          this.arrow = this.el.querySelector('[arrow]');
          this.af = AF.instance();
          this.activate = this.activate.bind(this);
          this.deactivate = this.deactivate.bind(this);
          this.hide = this.hide.bind(this);
          this.show = this.show.bind(this);
          this.write = this.write.bind(this);
          this.onMove = this.onMove.bind(this);
          this.onDown = this.onDown.bind(this);
          this.onUp = this.onUp.bind(this);
          this.init();
      }
  }

  init() {
      window.addEventListener('mousemove', this.onMove);
      window.addEventListener('mousedown', this.onDown);
      window.addEventListener('mouseup', this.onUp);
      // window.addEventListener('mouseleave', this.onUp);
  }

  activate(type) {
      if (!this.initialised) return;
      if (this.active && type === this.currentType) return;
      // console.log('Click Cursor: activate');
      this.currentType = type;
      this.active = true;

      this.af.onNextWrite(() => {
          this.el.classList.add(CLASS_ACTIVE);

          if (this.currentType === 'back') {
              this.el.classList.add(CLASS_BACK);
              this.el.classList.remove(CLASS_NEXT);
          } else if (this.currentType === 'next') {
              this.el.classList.remove(CLASS_BACK);
              this.el.classList.add(CLASS_NEXT);
          } else {
              this.el.classList.remove(CLASS_BACK);
              this.el.classList.remove(CLASS_NEXT);
          }
      });

      this.af.addWrite(this.write);
  }

  deactivate() {
      if (!this.initialised) return;
      if (!this.active) return;
      this.active = false;
      this.af.onNextWrite(() => {
          this.el.classList.remove(CLASS_ACTIVE);
      });
      this.af.removeWrite(this.write);
  }

  hide() {
      if (!this.initialised) return;
      if (!this.active) return;
      this.af.onNextWrite(() => {
          this.el.classList.add(CLASS_HIDDEN);
      });
  }

  show() {
      if (!this.initialised) return;
      if (!this.active) return;
      this.af.onNextWrite(() => {
          this.el.classList.remove(CLASS_HIDDEN);
      });
  }

  write() {
      if (!this.active) return;
      this.arrow.style.transform = 'translate3d('+ this.x +'px, '+ this.y +'px, 0)';
  }

  onMove(e) {
      if (!this.active) return;
      this.x = e.clientX;
      this.y = e.clientY;
  }

  onDown() {
      // console.log('Click cursor: onDown', !this.active, this.pressed);
      if (!this.active) return;
      if (this.pressed) return;
      this.pressed = true;
      this.af.onNextWrite(() => {
          this.el.classList.add(CLASS_PRESSED);
      });
  }

  onUp() {
      // console.log('Click cursor: onUp', !this.active, !this.pressed);
      if (!this.active) return;
      if (!this.pressed) return;
      this.pressed = false;
      this.af.onNextWrite(() => {
          this.el.classList.remove(CLASS_PRESSED)
      });
  }
}